/* Stienhardt - diamond 360 OPEN/CLOSE gate (2026-06-26, robust rewrite)
   Owns the whole gate so it survives unlimited tap/X cycles. The facade is
   only HIDDEN/SHOWN (never removed, no cloning) -> nothing can desync.
   - Capture-phase tap on .sp-360-facade takes over (blocks the core
     diamonddetail.js handler via stopImmediatePropagation) and opens the
     gem360 viewer ourselves.
   - X closes: removes the iframe, shows the facade again, unlocks swiping.
   - Swipe is locked ONLY while the viewer is open.
   Revert = remove this file + its <script>. */
(function () {
  'use strict';

  function slideOf(el) { return el && el.closest ? el.closest('.video-slide') : null; }
  function lock(slide, on) {
    try { if (on) slide.classList.add('swiper-no-swiping'); else slide.classList.remove('swiper-no-swiping'); } catch (e) {}
  }

  function addX(slide) {
    if (slide.querySelector('.sp-360-exit')) return;
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'sp-360-exit';
    x.setAttribute('aria-label', 'Close 360 view');
    x.innerHTML = '&times;';
    x.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); closeViewer(slide); });
    slide.appendChild(x);
  }

  function openViewer(fac) {
    var slide = slideOf(fac) || fac.parentNode;
    if (!slide || slide.querySelector('iframe')) return; // already open
    var src = fac.getAttribute('data-viewer-src');
    if (!src) return;
    try { slide.style.position = 'relative'; } catch (e) {}
    var f = document.createElement('iframe');
    f.setAttribute('scrolling', 'no');
    f.src = (src.indexOf('gem360') > -1 && src.indexOf('controls=') === -1)
      ? (src + (src.indexOf('?') > -1 ? '&' : '?') + 'controls=0') : src;
    f.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;z-index:2;';
    fac.style.display = 'none';
    slide.appendChild(f);
    lock(slide, true);
    addX(slide);
  }

  function closeViewer(slide) {
    if (!slide) return;
    try {
      var ifrs = slide.querySelectorAll('iframe');
      for (var i = 0; i < ifrs.length; i++) { if (ifrs[i].parentNode) ifrs[i].parentNode.removeChild(ifrs[i]); }
      var x = slide.querySelector('.sp-360-exit'); if (x && x.parentNode) x.parentNode.removeChild(x);
      var fac = slide.querySelector('.sp-360-facade'); if (fac) fac.style.display = '';
    } catch (e) {}
    lock(slide, false);
  }

  // Take over the facade tap (capture) so only WE manage open/close.
  document.addEventListener('click', function (e) {
    var fac = e.target && e.target.closest ? e.target.closest('.sp-360-facade') : null;
    if (!fac) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openViewer(fac);
  }, true);

  // Keep swipe-lock honest: any 360 slide with no open viewer must be unlocked
  // (theme markup ships swiper-no-swiping always-on, which traps the poster).
  function syncLocks() {
    try {
      document.querySelectorAll('.diamond-product-template .video-slide').forEach(function (slide) {
        lock(slide, !!slide.querySelector('iframe'));
      });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncLocks); else syncLocks();
  [400, 900, 1800, 3500].forEach(function (t) { setTimeout(syncLocks, t); });
  var mp = document.getElementById('mainproduct');
  if (mp) new MutationObserver(syncLocks).observe(mp, { childList: true, subtree: true });
})();
